var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    padding: spacing.xxSmall,
    borderWidth: borders.widthMedium,
    borderColor: colors.contrasts.grey1214,
    borderRadius: borders.radiusMedium,
    backgroundColor: colors.contrasts.white1010,
    bodyPaddingLeft: spacing.xxSmall,
    bodyPaddingRight: spacing.xSmall,
    actionIconPadding: spacing.xxxSmall
  };
};
export default generateComponentTheme;